"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageConfig = void 0;
const needle_1 = require("./needle");
const contentTypes = require("./content-types");
const registry_call_1 = require("./registry-call");
const options_1 = require("./options");
/**
 * Retrieves the image configuration blob for a container image.
 *
 * Fetches the configuration blob containing image metadata such as environment variables,
 * exposed ports, volumes, working directory, command/entrypoint, and other runtime configuration.
 * This is typically a JSON blob identified by the digest from the image manifest.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/blobs/<digest>`
 *
 * @param registryBase - The base URL of the container registry
 * @param repo - The repository name (e.g., "library/nginx")
 * @param digest - The blob digest (e.g., "sha256:abc123...")
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param options - Optional request configuration options
 * @param observer - Optional observer to record client events
 *
 * @returns Parsed image configuration object
 *
 * @throws {NeedleWrapperException} When blob not found or HTTP errors occur
 */
async function getImageConfig(registryBase, repo, digest, username, password, options = {}, observer) {
    const cloned = (0, options_1.cloneOptions)(options);
    const endpoint = `/${repo}/blobs/${digest}`;
    const configResponse = await (0, registry_call_1.registryV2Call)(registryBase, endpoint, contentTypes.IMAGE_CONFIG, username, password, cloned, observer);
    return (0, needle_1.parseResponseBody)(configResponse);
}
exports.getImageConfig = getImageConfig;
//# sourceMappingURL=get-image-config.js.map